import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p01 } from "../../../layouts/ch6_p01/ch6_p01";

export class Chapter6Page1 extends AbstractStoryState implements ReturnType<typeof ch6_p01> {

    readonly bg = this.addChild(new SceneSprite());
    readonly bushes = this.addChild(new SceneSprite());
    readonly path = this.addChild(new SceneSprite());
    readonly tree = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());
    readonly rain = [
        this.addChild(SceneSprite.withPrefix("ch6_p01/")),
        this.addChild(SceneSprite.withPrefix("ch6_p01/")),
    ];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p01/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p01/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p01/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p01.call(this);

        this.rain[0].z = 1;
        this.rain[1].z = 2;
        this.holly.z = 3;
        this.tyler.z = 3;
        this.horse.z = 4;
        this.tree.z = 5;
        this.path.z = 6;
        this.bushes.z = 6;
        this.bg.z = 7;
        this.linesLeft.z = 7;
        this.linesRight.z = 7;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        const duration = 8;

        this.makeParallax([
            this.bg,
            this.bushes,
            this.path,
            this.tree,
            this.horse,
            this.holly,
            this.tyler,
            this.linesLeft,
            this.linesRight,
            ...this.rain,
        ], {duration, distance: 8, spread: 5});

        TweenLite.delayedCall(duration, () => {
            this.gotoNextState({ transition: "left" });
        });
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
    }
}